import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	submitSuccessTitle: {
		id: 'project-details.submit-success-flag-header',
		defaultMessage: 'Success!',
		description: '',
	},
	submitSuccessDescription: {
		id: 'project-details.submit-success-flag-description',
		defaultMessage: 'Project details successfully updated.',
		description: '',
	},
	releaseProjectKeysErrorTitle: {
		id: 'project-details.release-project-key-error-flag-header',
		defaultMessage: 'We’re unable to delete previous project keys',
		description: 'A header for the flag presented when previous project keys cannot be released',
	},
	deleteProjectSuccessTitle: {
		id: 'project-details.delete-project-success-flag-header',
		defaultMessage: 'Project deleted!',
		description: '',
	},
	deleteProjectSuccessDescription: {
		id: 'project-details.delete-project-success-flag-description',
		defaultMessage: 'You will never hear from project “{projectName}” again.',
		description: '',
	},
	deleteProjectFailTitle: {
		id: 'project-details.delete-project-fail-flag-header',
		defaultMessage: "Couldn't delete",
		description: '',
	},
	deleteProjectFailDescription: {
		id: 'project-details.delete-project-fail-flag-description',

		defaultMessage:
			'There was a network problem and we couldn’t delete “{projectName}”. Try again later.',

		description: '',
	},
	genericErrorTitle: {
		id: 'project-details.generic-error-header',
		defaultMessage: "Couldn't save",
		description: '',
	},
	genericErrorDescription: {
		id: 'project-details.generic-error-description',

		defaultMessage:
			'There was a network problem and the project details were not updated. Try again later.',

		description: '',
	},
});
